const initialState = {
  isOpenSideBar: false
};

export default initialState;
